import React from 'react';

export const FooterLanguageSelector: React.FC = () => null;
